import styled from '@emotion/styled';

export const SectionWrapper = styled('div', { label: 'SectionWrapper' })`
    display: flex;
    flex-flow: column nowrap;
    flex: 1 1 0%;
`;
